import React from "react";
import { motion } from "framer-motion";
import { DS } from "../../../utils/designSystem";
import { fadeIn } from "../../common/motionFrameVarients";

const STATS = [
  { count: "2,500+", label: "Lives Impacted",    sub: "through SPAF programmes" },
  { count: "10K+",   label: "Active Students",   sub: "learning on KodeVedic" },
  { count: "200+",   label: "Courses",            sub: "across all skill levels" },
  { count: "8+",     label: "Community Drives",  sub: "serving tribal schools" },
];

const StatsComponent = () => {
  return (
    <section className={`${DS.layout.sectionCompact} border-b border-richblack-700 bg-richblack-800`}>
      <div className={DS.layout.container}>
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
          {STATS.map(({ count, label, sub }, i) => (
            <motion.div
              key={label}
              variants={fadeIn("up", 0.06 * i)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              className="flex flex-col items-center gap-1 text-center py-4"
            >
              <span className="text-3xl lg:text-4xl font-bold text-richblack-5">{count}</span>
              <span className="text-base font-semibold text-yellow-50">{label}</span>
              <span className={DS.text.caption}>{sub}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsComponent;
